import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/MarketPlace/PaymentDetailsTransportation.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import CancelModal from '../../Shared/CancelModalMarketPlace';
import RejectModal from '../../Shared/TranspotationRejectModal';
import Input from '../../Shared/Input';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import bigBlankStar from '../../../Assets/NominateRequest/starBlank_large.svg';
import bigFilledStar from '../../../Assets/NominateRequest/starFilled_large.svg';
import StarRatingModal from '../../Shared/StarRatingModal';
import Message from '../../../Data/Shared/Message.json';
import '../../../css/Shared/FilesWithStarModal.css';
import SuccessModal from '../../Shared/SuccessModal';
import { ApiCall } from '../../../Services/utils/ApiCall';

import { serviceBaseURL ,baseURL} from '../../../Services/config/apiGateway';
import { SUBSCRIPTION_PAYMENT_ENDPOINT, SERVICE_PAYMENT_ENDPOINT } from '../../../Services/config/apiEndPoints';
class PaymentDetailsTransportation extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceIdValue: 0,
            serviceCharge: 0,
            transactionFees: 0,
            discount: 0,
            discountPercentage: "",
            beforeTaxes: 0,
            VAT: 0,
            VATPercentage: "",
            orderTotal: 0,

            hasOpen: false,
            hasOPenReject: false,
            reason: '',
            reasonTextLimit: 0,
            hasOpenRating: false,
            ratingStar: '',
            errorStarReason: "",
            hasOpenSuccess: false,
            paymentReferenceNum: '',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    onYesModal = () => {
        this.setState({ hasOpen: false });
    };
    onCloseModal = () => {
        this.setState({ hasOpen: false });
    };
    onCloseModalSuccess = ()=>{
        this.setState({ hasOpenSuccess: false });
        this.props.history.push('/home', {});
    }
    onCloseReject = () => {
        this.setState({ hasOPenReject: false });
    };
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
        }
    }
    updateRating = (index) => {
        this.setState({ ratingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }
    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpenRating: false });
        }
    };
    handleValidationModel = () => {
        let errorStarReason = '';
        let formIsValid = true;
        if (this.state.hasOpenRating == true) {
            if (!this.state.ratingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
        }
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }
    componentDidMount = () => {
        const { serviceId } = this.props.match.params;
        this.setState({
            serviceIdValue: serviceId
        });
        document.addEventListener("mousedown", this.handleClickOutside);
        this.getPaymentDetailsData();
    }
    getPaymentDetailsData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_PAYMENT_ENDPOINT + `?serviceRequestId=${this.state.serviceIdValue}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            apiData = {
                "serviceCharge": 0,
                "transactionFees": 100,
                "discount": 1,
                "discountPercentage": "10%",
                "amountBeforeTax": 9,
                "VAT": 1.35,
                "vatPercentage": "15%",
                "orderTotal": 161.35
            }
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        serviceCharge: apiData?.serviceCharge,
                        transactionFees: apiData?.transactionFees,
                        discount: apiData?.discount,
                        discountPercentage: apiData?.discountPercentage,
                        beforeTaxes: apiData?.amountBeforeTax,
                        VAT: apiData?.VAT,
                        VATPercentage: apiData?.vatPercentage,
                        orderTotal: apiData?.orderTotal
                    });
                }
            }
        });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            //
        }
    };
    onProceed = () => {
        ApiCall(
            'POST',
            baseURL + SUBSCRIPTION_PAYMENT_ENDPOINT,
           
            {
                "amount": this.state.beforeTaxes,
                "orderDate": Math.round(new Date().getTime()),
                "paymentMethod": "string",
                "paymentReference": 0,
                "planId":0 ,
                "tax":0 ,
                "tenure": '',
                "totalAmount": this.state.orderTotal,
                "invoicePDF": "string"
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        )
            .then((data) => {
                console.log('functions', data);
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log('In 500!');
                    }
                    else {
                        console.log('In 200!');
                      
                        this.setState({
                            paymentReferenceNum: data?.transactionId,
                            hasOpenSuccess: true
                        });
                    }
                }
                else {
                    console.log('some error');
                }
            })
    }
    render() {
        return (
            <div class="MPaymentDOutercolor">
                <MetaDecorator title={TitleDescription.PaymentDetailsTransportationTitle} description={TitleDescription.PaymentDetailsTransportationDescription} />
                <Header tilesFetched={() => { }} />
                <div class="MPaymentDOuterDivcss">
                    <div id="MPaymentDBoxDiv">
                        <nav class="MPaymentDNavbar">
                            <div className="MPaymentDNavbarName">
                                <small id="MPaymentDNavbarText">Payment Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="MPaymentDMidPartition">
                            <div class="MPaymentDCardCss">
                                <div class="MPaymentDCardInner">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Service Charge</small>
                                        {this.state.serviceCharge ?
                                            <small class="MPaymentDCardOrderRight">R {this.state.serviceCharge}</small>
                                            :
                                            <small class="MPaymentDCardOrderRight">NA*</small>
                                        }
                                    </div>
                                </div>
                                <div class="MPaymentDCardInner">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Transaction Fees</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.transactionFees}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Discount ({this.state.discountPercentage})</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.discount}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Before Taxes</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.beforeTaxes}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">VAT ({this.state.VATPercentage})</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.VAT}</small>
                                    </div>
                                </div>
                                <div class="MPaymentDCardOrder">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardOrderLeft">Order Total</small>
                                        <small class="MPaymentDCardOrderRight">R {this.state.orderTotal}</small>
                                    </div>
                                </div>
                            </div>
                            {!this.state.serviceCharge &&
                                <div class='serviceChargeDiv'>*
                                <small class="serviceChargeLeft"> Service Charge </small>
                                    <small class='serviceChargeRight'>to be settled directly with Respondent in accordance with the agreed payment
terms stipulated on the service response.</small>
                                </div>
                            }
                            <div class="MPaymentDBtnDiv">
                                <Button class="MPaymentDBtnCss" onClick={this.onProceed}>
                                    <small class="MPaymentDBtntext">Proceed To Pay</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="MPaymentDFooterUnfixed">
                    <Footer />
                </div>
                <div class="MPaymentDFooterFixed">
                    <Footer2 />
                </div>

                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="cancelTransportationServiceDiv">
                            <small class="transportationServiceText">{Message.marketPlace.cancelModalQuery}</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'>If you have already made the payment the refund</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'> will be initiated based on the cancellation policy.</small>
                            <small class="transportationServiceTextSmall" id='transportationMobile'>{Message.marketPlace.cancelModalNote}</small>
                        </div>
                    </div>
                </CancelModal>
                {this.state.hasOPenReject ? <RejectModal hasOpen={this.state.hasOPenReject} onCloseModal={this.onCloseReject} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="rejectModalHeading">{Message.marketPlace.rejectModalQuery}</small>
                        </div>
                        <div class="rejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your reason"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </RejectModal> : null}
                <StarRatingModal hasOpen={this.state.hasOpenRating} onCloseModal={() => this.onSumbitRating()}>
                    <div class="newratingDivOut">
                        <div class="newratingHeadDiv">
                            <small class="newratingHeadsm">{Message.marketPlace.starRatingModalRateQuery}</small>
                        </div>
                        <div class="newratingLowerSectionDiv">
                            <div class="newratingNameHeadingDiv">
                                <small class="newratingNameHeading">{Message.marketPlace.starRatingModalCompanyName}</small>
                            </div>
                            <div class="newratingImgDiv">
                                <div class="newratingImgDivin">
                                    {[1, 1, 1, 1, 1].map((item, index) => (
                                        <div class="newratingmodalimgposition"
                                            onClick={() => this.updateRating(index)}
                                            key={index}
                                        >
                                            <img src={index < this.state.ratingStar ? bigFilledStar : bigBlankStar} class="newratingImgStar" height="26" width="26" alt="" loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                                <div className="newratingstarunfillerror">{this.state.errorStarReason}</div>
                            </div>
                        </div>
                        <div class="rejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your comment"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </StarRatingModal>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModalSuccess}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Payment successful</small>
                            <small class="successRatingdivsm">Transaction Id. {this.state.paymentReferenceNum}</small>
                        </div>
                    </div>
                </SuccessModal>
            </div >
        );
    }
}
export default PaymentDetailsTransportation;